import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../fetch';
import { baseUrl, customHeaders, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';

import { GET_FILE_SUMMARY, GET_FILE_SUMMARY_SUCCESS, GET_FILE_SUMMARY_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* getFileSummary({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/row-summary`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({ type: GET_FILE_SUMMARY_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: GET_FILE_SUMMARY_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: GET_FILE_SUMMARY_ERROR, payload: error });
  }
}

export function* watchGetFileSummary() {
  yield takeEvery(GET_FILE_SUMMARY, getFileSummary);
}

function* getFileSummarySaga() {
  yield all([fork(watchGetFileSummary)]);
}

export default getFileSummarySaga;
